import React from 'react';
import { useSelector } from 'react-redux';
import { StaticLinkButton } from 'Components/Fields/Buttons';
import './HomeContainer.css';

export const HomeComponent = () => {
  const routes = useSelector((s) => s.appConfig.routes);

  return (
    <div>
      <p className="landingPlaceholder">
        This is a placeholder page. In Production, the MLP team manages the landing page from a different codebase.
        Please disregard this NATCOM placeholder page.
      </p>
      <StaticLinkButton path={routes.signupPlans} text="Select Plans Page" className="continueWatching" />
      <StaticLinkButton path={routes.signin} text="Sign In Page" className="continueWatching" />
    </div>
  );
};

export const HomeContainer = HomeComponent;
